export default __webpack_public_path__ + "static/media/NotoSans-Thin.5f9a1e0f.eot";